import { Component, Inject, OnInit } from "@angular/core";
import { UntypedFormBuilder, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
// import { ToastrService } from "ngx-toastr";
import { fromEvent } from "rxjs";
import { API_ROUTES } from "src/app/core/_constants/api-route.constant";
import { RouteConstant } from "src/app/core/_constants/route.constant";
import { ApiServicesService } from "src/app/services/apiServices/api-services.service";
import { CommonService } from "src/app/services/common.service";
import { LocalStorageProvider } from "src/app/services/storage/storage.service";
import { AddFieldComponent } from "src/app/shared/dialogs/add-field/add-field.component";
import { PostPublishComponent } from "src/app/shared/dialogs/post-publish/post-publish.component";

@Component({
  selector: "app-choose-interest",
  templateUrl: "./choose-interest.component.html",
  styleUrls: ["./choose-interest.component.scss"],
})
export class ChooseInterestComponent implements OnInit {
  loginForm: any;
  interestName: any;
  interestArray: any;
  selectDummyUserId: any = [];
  selectedCustom: any = [];
  selectUserId: any = [];
  submitted: boolean = false;
  centered = false;
  disabled = false;
  unbounded = false;
  customFields: any = [];
  profileDetails: any;
  constructor(
    // private toastr: ToastrService,
    private commonService: CommonService,
    private dialog: MatDialog,
    private service: ApiServicesService,
    private router: Router,
    private fb: UntypedFormBuilder,
    private storageService: LocalStorageProvider,
    private sharedService: CommonService
  ) { }
  isCompanyInterest: any;
  ngOnInit(): void {
    this.isCompanyInterest = this.storageService.getItem("companyInterest");
    // debugger;
    fromEvent(window, "popstate").subscribe((e) => {
      e.preventDefault();
      this.storageService.setItem("preventback", "yes");
    });
    this.loginForm = this.fb.group({
      interest: [this.selectDummyUserId],
      custom_interest: [this.selectedCustom],
    });
    this.onGetInterest();
    this.getProfile();
  }

  getProfile() {
    this.service
      .get({}, `${API_ROUTES.More.moreDetails}`)
      .pipe()
      .subscribe(
        (res) => {
          this.profileDetails = res.result[0];
        },
        (error) => {
          // this.toastr.error(error.message);
        }
      );
  }

  onGetInterest() {
    this.service
      .get({}, `${API_ROUTES.Account.getInterest}`)
      .pipe()
      .subscribe((res) => {
        this.interestName = res.result;
      });
  }
  closePopup: boolean = false;
  onVerify(post: any) {
    // debugger;
    this.submitted = true;
    if (this.selectDummyUserId.length < 3) {
      // this.toastr.error("minimum 3 interests select");
    } else {
      this.service
        .post(post, `${API_ROUTES.Account.chooseInterest}`, {})
        .pipe()
        .subscribe((res) => {
          this.closePopup = true;
          if (this.isCompanyInterest != "false") {
            // Trigger the social mandate popup
            localStorage.setItem("this.isCompanyInterest", "true");
            const logintype = localStorage.getItem("loginType");
            if (logintype == "1") {
              this.commonService.triggerSocialMandatePopup();
            }
          }

          if (this.isCompanyInterest == false) {
            this.sharedService.sendData(this.closePopup);
            this.service
              .get({}, API_ROUTES.More.weightageCalculation)
              .pipe()
              .subscribe((res) => { });
            this.commonService.signup(
              this.profileDetails.Auth.email,
              this.profileDetails.Auth.email
            );
            this.router.navigate([
              "/" + RouteConstant.main + "/" + RouteConstant.home,
            ]);

            this.dialog.closeAll();
          }
          // localStorage.removeItem("companyInterest");
          this.storageService.setItem("companyInterest", true);
          localStorage.removeItem("companyInterest");
          if (this.isCompanyInterest != false) {
            const screenWidth = window.innerWidth;
            let isSmallScreen = false;
            if (screenWidth <= 1440) {
              isSmallScreen = true;
            }
            const dialogRef = this.dialog.open(PostPublishComponent, {
              maxHeight: "100vh",
              width: isSmallScreen ? '300px' : '465px',
              height: isSmallScreen ? '250px' : '400px',
              panelClass: "resetPassword",
              data: {
                img: "assets/images/Completed_check.svg",
                heading: "Your account created successfully",
                // title:'Your account has been successfully created',
                image: "assets/images/logout_3.svg",
                btn: "Take me to home",
              },
            });

            dialogRef.afterClosed().subscribe((result) => {
              this.service
                .get({}, API_ROUTES.More.weightageCalculation)
                .pipe()
                .subscribe((res) => { });
              this.commonService.signup(
                this.profileDetails.Auth.email,
                this.profileDetails.Auth.email
              );
              this.router.navigate([
                "/" + RouteConstant.main + "/" + RouteConstant.home,
              ]);
            });
          }
        });
    }
  }

  interest() { }

  addCustom() {
    const dialogRef = this.dialog.open(AddFieldComponent, {
      maxHeight: "100vh",
      width: "450px",
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.data != null) {
        this.customFields.push(result.data);
      }
    });
  }

  remove(val: any) {
    this.customFields.splice(this.customFields.indexOf(val), 1);

    if (this.selectedCustom.includes(val)) {
      this.selectedCustom.splice(this.selectedCustom.indexOf(val), 1);
    }
  }

  selectUser(val: any, type: any) {
    if (type == 1) {
      if (this.selectDummyUserId.includes(val)) {
        this.selectDummyUserId.splice(this.selectDummyUserId.indexOf(val), 1);

        // this.selectUserId.splice(this.selectUserId.findIndex((v: any) => v.id === val), 1)
      } else {
        this.selectDummyUserId.push(val);
        // this.selectUserId.push({ 'id': val, 'priority': false })
      }
    } else {
      if (this.selectedCustom.includes(val)) {
        this.selectedCustom.splice(this.selectDummyUserId.indexOf(val), 1);

        // this.selectUserId.splice(this.selectUserId.findIndex((v: any) => v.id === val), 1)
      } else {
        this.selectedCustom.push(val);
        // this.selectUserId.push({ 'id': val, 'priority': false })
      }
    }
  }
}
